import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';

import Icon from '../../components/Icon';
import useLogout from '../../helpers/useLogout';

const LogoutItem = ({ isOpen }) => {
  const navigate = useNavigate();
  const { logout } = useLogout();

  const theme = useTheme();
  const { whiteColor } = theme.colors;

  const handleClick = () => {
    if (isLoggedIn) {
      logout();
    } else {
      navigate('/sign-in');
    }
  };

  const isLoggedIn = useSelector((state) => state.auth.cognitoUser);

  return (
    <div
      className="d-flex align-items-center"
      style={{ paddingLeft: 8, paddingRight: 8, height: 58 }}
    >
      <div
        className="left-navbar-button d-flex"
        onClick={handleClick}
        style={{
          width: isOpen ? 284 : 42,
        }}
      >
        <div
          style={{ width: 42, height: 42 }}
          className="d-flex align-items-center justify-content-center"
        >
          {!isLoggedIn && (
            <div>
              <Icon name="log-in-outline" color={whiteColor} />
            </div>
          )}
          {isLoggedIn && (
            <div>
              <Icon name="log-out-outline" color={whiteColor} />
            </div>
          )}
        </div>

        {isOpen && (
          <div
            className="d-flex align-items-center"
            style={{
              fontWeight: 500,
              flexGrow: 1,
              color: 'white',
              fontSize: 14,
            }}
          >
            {isLoggedIn ? (
              <FormattedMessage defaultMessage="Logga ut" />
            ) : (
              <FormattedMessage defaultMessage="Logga in" />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default LogoutItem;
